module.exports = __webpack_public_path__ + "img/SKMJ_limit12.2573dc3b.jpg";